module.exports = __webpack_public_path__ + "img/banner-en-desktop.1edd64ba.jpg";